import React, { isValidElement, cloneElement } from 'react';
import { getChildren } from '../../utils/bundle.esm2.js';
import ProductCardStyled from './bundle.esm3.js';
import ProductCardDescription from './ProductCardDescription/bundle.esm.js';
import ProductCardImage from './ProductCardImage/bundle.esm.js';
import ProductCardName from './ProductCardName/bundle.esm.js';

const ProductCardUI = (props) => {
  const { className, product, children, onClick } = props;
  const { attributes } = product;
  const renderChildren = () => {
    return getChildren(children).map((child, index) => {
      if (!child) {
        return null;
      }
      if (!isValidElement(child)) {
        return child;
      }
      return cloneElement(child, {
        key: index,
        product
      });
    });
  };
  if (!attributes.showInMenu) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(ProductCardStyled, {
    className: `ProductCard  ${className}`,
    onClick
  }, renderChildren());
};
ProductCardUI.Description = ProductCardDescription;
ProductCardUI.Image = ProductCardImage;
ProductCardUI.Name = ProductCardName;
ProductCardUI.defaultProps = {
  className: ""
};

export { ProductCardUI as default };
//# sourceMappingURL=bundle.esm4.js.map
